import { ThemedItinerary } from "@/components/ThemedItinerary";
import { spotImg } from "@/data/planner";
import { Link } from "react-router-dom";

const cfg = {
  testid: "winter-page",
  seo: {
    title: "Copenhagen in Winter: A Cosy 2-Day Itinerary (Tivoli Closed)",
    description:
      "What to do in Copenhagen in January, February and early March, when Tivoli is closed — a warm, indoor-led 2-day plan: Christiansborg Palace and the Thorvaldsens Museum, a heated canal tour, hot chocolate at La Glace, the Glyptotek's winter garden and the Royal Library's Black Diamond.",
    path: "/copenhagen-in-winter",
  },
  heroBg: "#13233B",
  heroImgId: "nyhavn",
  accent: "#7FB3D5",
  eyebrow: "DEEP WINTER · JAN–MID MARCH",
  h1: "Copenhagen",
  h1Italic: "in winter",
  intro:
    "Between the Christmas markets and the spring opening, Copenhagen goes quiet, grey and cold, completely different from summer. This is a warm, indoor-led two days built for the coldest months — museums, a heated canal boat tour and the very Danish ritual of hot chocolate and layer cake.",
  topNote: {
    title: "A note on winter:",
    body:
      "Tivoli is closed from 4 January until mid-March (it reopens for spring). Most museums, shops and the canal tours stay open all year — dress warm and lean into the hygge. One thing to plan around: most museums close on Mondays, so start this trip any day but Monday.",
  },
  days: [
    {
      label: "DAY ONE",
      title: "Palaces, sculpture &",
      titleAccent: "hot chocolate",
      blurb:
        "A warm day on Slotsholmen and the harbour: tour the royal reception rooms at Christiansborg and climb its free tower for a grey-sky panorama, then the colour-drenched sculpture halls of the Thorvaldsens Museum next door. Wrap up along Nyhavn, take a heated canal tour (they run all year), and finish with legendary hot chocolate and layer cake at La Glace, Denmark's oldest patisserie.",
      ids: ["christiansborg", "thorvaldsens", "nyhavn", "canaltour", "laglace"],
      extras: ["sanktpeders", "magstraede"],
    },
    {
      label: "DAY TWO",
      title: "Food halls, art &",
      titleAccent: "the Black Diamond",
      blurb:
        "Start with a warming graze through the covered Torvehallerne food market, then wander down Strøget to the Glyptotek — ancient sculpture and a palm-filled winter garden under its glass dome. Learn the city's own story at Københavns Museum, and end at the Royal Library's Black Diamond, stepping into its soaring harbourfront atrium for free.",
      ids: ["torvehallerne", "stroget", "glyptoteket", "kbhmuseum", "sortdiamant"],
      notes: {
        stroget:
          "The long pedestrian shopping street through the centre. Walk from Torvehallerne through Frederiksborggade/Købmagergade towards Amagertorv and to Glyptoteket",
      },
      extras: [
        "nationalmuseet",
        "dac",
        {
          key: "winter-lunch",
          node: (
            <>
              A long, traditional Danish{" "}
              <Link
                to="/smorrebrod"
                className="font-800 text-black underline underline-offset-2 decoration-black/30 hover:decoration-black transition-colors"
              >
                smørrebrød
              </Link>{" "}
              lunch is a lovely idea too — the perfect slow, cosy winter meal.
            </>
          ),
        },
      ],
    },
  ],
  cta: { title: "Planning a winter trip?", titleItalic: "It loads straight into the planner" },
  shareTitle: "Copenhagen in Winter — A Cosy 2-Day Itinerary",
  schemaName: "Copenhagen in Winter — A Cosy 2-Day Itinerary",
  heroImg: spotImg("nyhavn", 1600),
  explore: [
    { label: "Month-by-month — what Copenhagen is like in winter", to: "/copenhagen-in/january" },
    { label: "Rainy & cold-day rescues", to: "/rainy-day" },
    { label: "Build your own version — the free planner", to: "/planner" },
  ],
};

export default function WinterPage() {
  return <ThemedItinerary cfg={cfg} />;
}
